export const ActionTypes = {
  SET_RETENTIONS: "WHOLESALER_RETENTIONS_SET_RETENTIONS",
  SET_FILTERS: "WHOLESALER_RETENTIONS_SET_FILTERS",
  CLEAR_RETENTIONS: "WHOLESALER_RETENTIONS_CLEAR_RETENTIONS",
  RESTORE_INITIAL: "WHOLESALER_RETENTIONS_RESTORE_INITIAL",
  ADD_RETENTION: "WHOLESALER_RETENTIONS_ADD_RETENTION",
  UPDATE_RETENTION_STATUS: "WHOLESALER_RETENTIONS_UPDATE_STATUS",
  REMOVE_RETENTION: "WHOLESALER_RETENTIONS_REMOVE",
  SET_RETENTION_DETAILS: "WHOLESALER_RETENTIONS_SET_DETAILS",
  SET_RETENTION_BALANCE: "WHOLESALER_RETENTIONS_SET_BALANCE",
};
